import { Component, OnInit } from '@angular/core';
import {CardTextInfo} from "../models/card_textsmaster";
import {CardTextsService} from "../services/card_texts.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-cardview',
  templateUrl: './card_textsview.component.html',
})
export class CardTextsviewComponent implements OnInit {

    cardtextsinfo:CardTextInfo;
    constructor(
        private cardImageService:CardTextsService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.getCardTextInfo()
    }
    getCardTextInfo=function () {
        console.log(this.activatedRoute)
        this.activatedRoute.params.subscribe(params => {
            let card_texts_id = params['id'];
            console.log("CardTextId======>",card_texts_id); // Print the parameter to the console.
            this.cardImageService.getCardTextInfo(card_texts_id).then(data => {
                console.log("CardTextsInfo=======>",data['data']);
                this.cardtextsinfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/card_textsmaster/card_textsview/card_textsview.component.ts